import React from "react";

const LpServicesHead = () => {
  return (
    <div className="lpServicesHead-container">
      <div className="lpServicesHead-content">
        <h5>Our Services</h5>
      </div>
      <h2>
        Explore Our <span>Services</span>
      </h2>
    </div>
  );
};

export default LpServicesHead;
